export const bloodTypes: ReactSelectOption[] = [
	{ value: "A+", label: "A+" },
	{ value: "A-", label: "A-" },
	{ value: "B+", label: "B+" },
	{ value: "B-", label: "B-" },
	{ value: "AB+", label: "AB+" },
	{ value: "AB-", label: "AB-" },
	{ value: "O+", label: "O+" },
	{ value: "O-", label: "O-" },
];
